import React, { useState } from 'react';
import { experiences, organizations } from '../data/portfolioData';

const C = {
  cyan: '#00f5ff', green: '#00ff88', purple: '#7b2fff',
  gray: '#4a6275', white: '#e8f4f8',
  border: 'rgba(0,245,255,0.12)',
  card: 'rgba(0,245,255,0.025)',
};

function TimelineItem({ item, index, type }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: 'relative', paddingLeft: 36, marginBottom: 44,
        transition: 'all .3s',
      }}
    >
      {/* Dot */}
      <div style={{
        position: 'absolute', left: -5, top: 6,
        width: 10, height: 10, borderRadius: '50%',
        background: hovered ? C.cyan : 'rgba(4,8,16,0.8)',
        border: `2px solid ${hovered ? C.cyan : 'rgba(0,245,255,0.4)'}`,
        boxShadow: hovered ? `0 0 14px ${C.cyan}` : 'none',
        transition: 'all .3s',
        zIndex: 1,
      }} />

      {/* Content card */}
      <div style={{
        background: hovered ? 'rgba(0,245,255,0.03)' : C.card,
        border: `1px solid ${hovered ? 'rgba(0,245,255,0.3)' : C.border}`,
        padding: '24px 24px',
        transition: 'all .3s',
        transform: hovered ? 'translateX(4px)' : 'translateX(0)',
      }}>
        <div style={{
          fontFamily: "'Space Mono', monospace", fontSize: 9,
          letterSpacing: 2, textTransform: 'uppercase',
          color: type === 'org' ? C.purple : C.cyan,
          marginBottom: 8, display: 'flex', alignItems: 'center', gap: 12,
          flexWrap: 'wrap',
        }}>
          {item.period}
          {item.type && (
            <span style={{
              padding: '2px 8px',
              border: `1px solid ${C.border}`,
              color: C.green, fontSize: 8, letterSpacing: 1,
            }}>
              {item.type}
            </span>
          )}
        </div>

        <h3 style={{
          fontFamily: "'Orbitron', monospace",
          fontSize: 17, fontWeight: 600, color: C.white,
          marginBottom: 4, letterSpacing: 0.3,
        }}>
          {item.role}
        </h3>
        <div style={{
          fontSize: 13, color: C.gray, marginBottom: 16,
          letterSpacing: 0.5,
        }}>
          {item.company}
        </div>

        <ul style={{ listStyle: 'none', padding: 0 }}>
          {item.desc.map((d, i) => (
            <li key={i} style={{
              fontSize: 14, lineHeight: 1.8,
              color: 'rgba(232,244,248,0.58)',
              marginBottom: 6, paddingLeft: 16, position: 'relative',
            }}>
              <span style={{
                position: 'absolute', left: 0,
                color: hovered ? C.cyan : C.gray, transition: 'color .3s',
              }}>▸</span>
              {d}
            </li>
          ))}
        </ul>

        {item.tags && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 16 }}>
            {item.tags.map((t, i) => (
              <span key={i} style={{
                fontFamily: "'Space Mono', monospace", fontSize: 8,
                letterSpacing: 1.5, padding: '3px 9px',
                border: `1px solid rgba(0,245,255,0.18)`,
                color: C.gray, textTransform: 'uppercase',
              }}>
                {t}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default function Experience() {
  const [tab, setTab] = useState('work');

  return (
    <section id="experience" style={{ background: 'rgba(4,8,16,0.8)' }}>
      {/* Header */}
      <div style={{ marginBottom: 52 }}>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 12,
          fontFamily: "'Space Mono', monospace", fontSize: 10,
          letterSpacing: 4, textTransform: 'uppercase', color: C.cyan, marginBottom: 12,
        }}>
          <span style={{ width: 32, height: 1, background: C.cyan, display: 'inline-block' }} />
          Experience
        </div>
        <h2 style={{
          fontFamily: "'Orbitron', monospace",
          fontSize: 'clamp(26px, 4vw, 44px)',
          fontWeight: 700, color: C.white, letterSpacing: -1,
        }}>
          Work & <span style={{ color: C.cyan }}>Activities</span>
        </h2>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 0, marginBottom: 44, width: 'fit-content' }}>
        {[['work', 'Work Experience'], ['org', 'Organizations']].map(([key, label]) => (
          <button key={key}
            onClick={() => setTab(key)}
            style={{
              fontFamily: "'Space Mono', monospace", fontSize: 10,
              letterSpacing: 2, textTransform: 'uppercase',
              padding: '10px 24px', border: 'none', cursor: 'pointer',
              background: tab === key ? C.cyan : 'transparent',
              color: tab === key ? '#020409' : C.gray,
              borderBottom: `2px solid ${tab === key ? C.cyan : C.border}`,
              fontWeight: tab === key ? 700 : 400,
              transition: 'all .25s',
            }}
          >
            {label}
          </button>
        ))}
      </div>

      {/* Timeline */}
      <div style={{ position: 'relative', maxWidth: 860 }}>
        {/* Timeline line */}
        <div style={{
          position: 'absolute', left: 0, top: 0, bottom: 0,
          width: 1,
          background: 'linear-gradient(to bottom, rgba(0,245,255,0.5), rgba(0,245,255,0.05))',
        }} />

        {(tab === 'work' ? experiences : organizations).map((item, i) => (
          <TimelineItem key={i} item={item} index={i} type={tab} />
        ))}
      </div>
    </section>
  );
}
